import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Typography } from '@material-ui/core';
import { OPEN_MODAL_ASSIGN } from 'redux/reducers/tanks/tanksReducer';
import gasTruckImage from '../../assets/img/crm/fuel-truck.png'
import stationGasImage from '../../assets/img/crm/station.png'
import AddCircleIcon from '@material-ui/icons/AddCircle';

export const columnsTanksUnits = [
  {
    Header: "Unidad",
    accessor: "number",
    filterable: true,
    filterMethod: (filter, row) => {
      return row.number.toLowerCase().includes(filter.value.toLowerCase())
    },
    Cell: ({original}) => {
      return (
        <Box style={{ display: 'flex' }}>
          <figure>
            <img src={gasTruckImage} alt="Camión de gas" />
          </figure>
        <Typography style={{ 
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center'
          }}>
          { original?.number }
          <Typography component="span" variant="caption" style={{
            backgroundColor: original.sync ? '#4caf50' : '#f44336',
            color: 'white',
            borderRadius: 15,
            padding: 5,
            width: 100,
            textAlign: 'center',
            opacity: .8
          }}>{  original.sync ? 'Disponible' : 'No Disponible' }</Typography>
          </Typography>
        </Box>
      )
    }
  },

  {
    Header: "Asignados",
    accessor: "value",
    filterable: true,
    Cell: ({ original }) => {
          return (
            <Typography  component={'span'} style={{
              display: 'flex',
              alignItems: 'center',
              }}
            >
                <figure>
                  <img src={stationGasImage} alt="Estación" style={{width: 30}}/>
                </figure>
              { original?.tanks ? `${original.tanks.length} asignados` : '0 tanques' }</Typography>
          )
        },
  },

  {
    Header: "Tanques Asignados",
    accessor: "tanks",
    filterable: true,
    Cell: ({ original }) => {
      const { tanks } = useSelector(state => state.tanks)
      const [mapData, setMapData] = useState([])
      
      useEffect(() => {
        if(original.tanks){
          setMapData(original?.tanks.map(key => tanks[key]))
        }
      }, [original, tanks])
          return (
            <>
            {
              original?.tanks &&
                <Box style={{ display: 'flex' }}>
                  {
                    mapData.map((tk, idx) => (
                      <p key={idx} style={{marginRight: 3, fontSize: 10}}>{ tk.name }{ idx === mapData.length -1 ? '.' : ',' }</p>
                    ))
                  }
                </Box>
            }
            </>
          )
        },
  },

  {
    Header: "Asignar Tanques",
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const handleOpen = () =>{
        dispatch({type: OPEN_MODAL_ASSIGN, payload: original})
      }
      return (
        
          <Button onClick={handleOpen} style={{float: 'right'}}><AddCircleIcon style={{color: '#1976d2', fontSize: 30}}/></Button>
      )
     },
  },
];